import { html, when } from '@microsoft/fast-element';
import { JSONForms } from './jsonforms/json-forms';
import { ArrayListWrapper } from './jsonforms/renderers/ArrayListWrapperRenderer';
import { CategorizationWrapper } from './jsonforms/renderers/CategorizationWrapperRenderer';
import { ControlWrapper } from './jsonforms/renderers/ControlWrapperRenderer';
import { DispatchRenderer } from './jsonforms/renderers/dispatch-renderer';
import { StepperWrapper } from './jsonforms/renderers/StepperWrapperRenderer';
JSONForms;
ArrayListWrapper;
CategorizationWrapper;
ControlWrapper;
DispatchRenderer;
StepperWrapper;
/** @internal */
export const getPrefixedForm = (prefix) => html `
  <template>
    <json-forms
      @submit-button-clicked=${(x) => x._submit()}
      @submit-part=${(x, c) => x.submitPart(c.event)}
      @reset-form=${(x) => x.reset(false)}
      ?readonly=${(x) => x.readonly}
      ?submitted=${(x) => x.submitted}
      :renderers=${(x) => x.renderers}
      :uischema=${(x) => x.uischema}
      :schema=${(x) => x.jsonSchema}
      :data=${(x) => x.data}
      :prefix=${(x) => x.prefix}
      @data-change=${(x, c) => x.onChange(c.event)}
    ></json-forms>
    ${when((x) => x.isSubmitHidden, html `
        <slot name="userActions" part="userActions" class="actions">
          <${prefix}-button
            @click="${(x) => x._submit()}"
            ?disable=${(x) => !x.submitting}
            class="submit-button"
            appearance="accent"
          >
            Submit
          </${prefix}-button>
        </slot>
      `)}
  </template>
`;
/** @internal */
export const foundationFormTemplate = html `
  ${(x) => getPrefixedForm(x.prefix)}
`;
